module.exports = __webpack_public_path__ + "static/img/home_medication_traditional.07cb35ad.webp";